import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.object.to-string";
import { __assign, __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import { loading, enumData, userPrefPageSize } from '@/decorators';
import EditModal from './editModal.vue';
import MoreWrapperModal from './moreWrapperModal.vue';
import PrintBoxMark from './printBoxMark/index.vue';
import { bulkRequest } from '@/utils/bulkRequest';
import util from '@/utils/util';
import { namespace } from 'vuex-class';
var User = namespace('user');
var printBoxMark = util.mountVueComponent(PrintBoxMark);

var ConsumablesInboundTabPage = function (_super) {
  __extends(ConsumablesInboundTabPage, _super);

  function ConsumablesInboundTabPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.dataList = [];
    _this.columns = [];
    _this.loadingStatus = false;
    _this.selectedList = [];
    _this.rowSelection = {};
    _this.datetimeDefaultValue = _this.$util.getDefaultTimeCondition();
    _this.addEditVisible = false;
    _this.moreWrapperVisible = false;
    _this.rowData = {};
    _this.inOrderStatusEnum = [];
    _this.packageOptionEnum = [{
      value: 'consumable_code',
      text: _this.t('耗材编码')
    }, {
      value: 'consumable_name',
      text: _this.t('耗材名称')
    }];
    _this.consumableTypeEnum = [];
    _this.wrapperTimeEnum = [{
      value: 'create_time',
      text: _this.t('创建时间')
    }, {
      value: 'submit_time',
      text: _this.t('提交时间')
    }, {
      value: 'receive_time',
      text: _this.t('收货时间')
    }, {
      value: 'discard_time',
      text: _this.t('废弃时间')
    }];
    _this.searchTimeType = 'create_time';
    _this.packageOrderCodeEnum = [{
      value: 'order_code',
      text: _this.t('耗材入库单号')
    }];
    _this.searchData = _this.initSearchData();
    _this.warehouseList = [];
    _this.lastParams = {};
    _this.total = 0;
    return _this;
  }

  ConsumablesInboundTabPage.prototype.created = function () {
    this.rowSelection = {
      selectedRowKeys: this.selectedList,
      onChange: this.onSelectChange
    };
    this.setColumns();
    this.queryList();
    this.queryWarehouseList();
  };

  ConsumablesInboundTabPage.prototype.setColumns = function () {
    this.columns = [{
      title: this.t('耗材入库单号'),
      dataIndex: 'order_code',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('状态'),
      dataIndex: 'status_text',
      filterEmpty: true
    }, {
      title: this.t('耗材类型'),
      dataIndex: 'consumable_type_text',
      filterEmpty: true
    }, {
      title: this.t('预报耗材信息'),
      dataIndex: 'consumable_list',
      scopedSlots: {
        customRender: 'consumable_list'
      }
    }, {
      title: this.t('收货信息'),
      dataIndex: 'receipt_list',
      scopedSlots: {
        customRender: 'receipt_list'
      }
    }, {
      title: this.t('入库仓库（区域）'),
      name: 'warehouse_code',
      scopedSlots: {
        customRender: 'warehouse_code'
      }
    }, {
      title: this.t('备注信息'),
      dataIndex: 'remark',
      filterEmpty: true
    }, {
      title: this.t('时间'),
      dataIndex: 'time',
      width: 200,
      scopedSlots: {
        customRender: 'time'
      }
    }, {
      width: 170,
      title: this.t('操作'),
      name: 'operation',
      fixed: 'right',
      scopedSlots: {
        customRender: 'operation'
      }
    }];
  };

  ConsumablesInboundTabPage.prototype.initSearchData = function () {
    return {
      status: undefined,
      order_code: undefined,
      consumable_option: 'consumable_code',
      consumable_option_value: undefined,
      consumable_code: undefined,
      consumable_name: undefined,
      consumable_type: undefined,
      warehouse_code: undefined,
      order_code_list: undefined,
      create_time_start: undefined,
      create_time_end: undefined,
      submit_time_start: undefined,
      submit_time_end: undefined,
      receive_time_start: undefined,
      receive_time_end: undefined,
      discard_time_start: undefined,
      discard_time_end: undefined,
      page_index: 1,
      page_size: 20
    };
  };

  ConsumablesInboundTabPage.prototype.onSelectChange = function (selectedRowKeys) {
    this.selectedList = this.rowSelection.selectedRowKeys = selectedRowKeys;
  };

  ConsumablesInboundTabPage.prototype.formatSearchData = function (params) {
    var newParams = this.$util.deepCopy(params);
    newParams.order_code_list = newParams.order_code ? [newParams.order_code] : undefined;
    delete newParams.order_code;
    newParams[newParams.consumable_option] = newParams.consumable_option_value;
    delete newParams.consumable_option;
    delete newParams.consumable_option_value;
    newParams[this.searchTimeType + "_start"] = this.datetimeDefaultValue.length ? this.$util.formatDateTime(this.datetimeDefaultValue[0]) : undefined;
    newParams[this.searchTimeType + "_end"] = this.datetimeDefaultValue.length ? this.$util.formatDateTime(this.datetimeDefaultValue[1]) : undefined;
    return newParams;
  };

  ConsumablesInboundTabPage.prototype.queryList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var params, data, list, total;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            params = this.formatSearchData(this.searchData);
            this.lastParams = params;
            this.total = null;
            return [4, this.$api.wrapper.queryConsumableMaterialInboundList(params)];

          case 1:
            data = _a.sent().data;
            list = data.list, total = data.total;
            this.dataList = list;
            this.total = total;
            return [2];
        }
      });
    });
  };

  ConsumablesInboundTabPage.prototype.handlePageChange = function (val) {
    this.searchData.page_index = val;
    this.selectedList.length = 0;
    this.queryList();
  };

  ConsumablesInboundTabPage.prototype.handleTabChange = function (key) {
    this.initPage();
    this.queryList();
  };

  ConsumablesInboundTabPage.prototype.initPage = function () {
    this.selectedList.length = 0;
    this.searchData.page_index = 1;
  };

  ConsumablesInboundTabPage.prototype.handleSearch = function () {
    this.initPage();
    this.queryList();
  };

  ConsumablesInboundTabPage.prototype.handleReset = function () {
    var _this = this;

    this.searchTimeType = 'create_time';
    this.searchData = this.initSearchData();
    this.datetimeDefaultValue = this.$util.getDefaultTimeCondition();
    this.$nextTick(function () {
      return _this.queryList();
    });
  };

  ConsumablesInboundTabPage.prototype.handleExport = function (isAll) {
    return __awaiter(this, void 0, Promise, function () {
      var postData, _a, code, data, message;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            postData = {};

            if (isAll) {
              postData = __assign({}, this.lastParams);
              delete postData.page_index;
              delete postData.page_size;
            } else {
              if (!this.selectedList.length) {
                return [2, this.$message.warn(this.t('common', this.$config.exportSelectedEmptyTip))];
              }

              postData = {
                order_code_list: this.selectedList
              };
            }

            return [4, this.$api.wrapper.exportConsumableMaterialInbound(postData)];

          case 1:
            _a = _b.sent(), code = _a.code, data = _a.data, message = _a.message;

            if (code === 0) {
              this.$util.exportExcel(data);
            } else {
              this.$message.error(message);
            }

            return [2];
        }
      });
    });
  };

  ConsumablesInboundTabPage.prototype.handleAdd = function () {
    this.rowData.title = this.t('新增耗材入库');
    this.rowData.data = null;
    this.addEditVisible = true;
  };

  ConsumablesInboundTabPage.prototype.handleEdit = function (record) {
    this.rowData.title = this.t('编辑耗材入库');
    this.rowData.data = record;
    this.addEditVisible = true;
  };

  ConsumablesInboundTabPage.prototype.handlePrint = function (data) {
    printBoxMark({
      parent: this,
      propsData: {
        data: data,
        onSuccess: function onSuccess() {}
      }
    });
  };

  ConsumablesInboundTabPage.prototype.handleDiscard = function (orderCode) {
    var _this = this;

    var modal = this.$confirm({
      title: this.t('废弃提示'),
      content: this.t('请确认是否废弃该记录？'),
      onOk: function onOk() {
        return __awaiter(_this, void 0, Promise, function () {
          var _a, code, message, error_1;

          return __generator(this, function (_b) {
            switch (_b.label) {
              case 0:
                _b.trys.push([0, 2,, 3]);

                return [4, this.$api.wrapper.discardConsumableMaterialInbound({
                  order_code: orderCode
                })];

              case 1:
                _a = _b.sent(), code = _a.code, message = _a.message;

                if (code === 0) {
                  this.$message.success(this.t('操作成功'));
                  this.queryList();
                  this.selectedList.length = 0;
                } else {
                  this.$message.error(message);
                }

                return [3, 3];

              case 2:
                error_1 = _b.sent();
                modal.destroy();
                return [3, 3];

              case 3:
                return [2];
            }
          });
        });
      }
    });
  };

  ConsumablesInboundTabPage.prototype.handleDelete = function (orderCode) {
    var _this = this;

    var modal = this.$confirm({
      title: this.t('删除提示'),
      content: this.t('请确认是否删除该记录？'),
      onOk: function onOk() {
        return __awaiter(_this, void 0, Promise, function () {
          var _a, code, message, error_2;

          return __generator(this, function (_b) {
            switch (_b.label) {
              case 0:
                _b.trys.push([0, 2,, 3]);

                return [4, this.$api.wrapper.deleteConsumableMaterialInbound({
                  order_code: orderCode
                })];

              case 1:
                _a = _b.sent(), code = _a.code, message = _a.message;

                if (code === 0) {
                  this.$message.success(this.t('操作成功'));
                  this.queryList();
                  this.selectedList.length = 0;
                } else {
                  this.$message.error(message);
                }

                return [3, 3];

              case 2:
                error_2 = _b.sent();
                modal.destroy();
                return [3, 3];

              case 3:
                return [2];
            }
          });
        });
      }
    });
  };

  ConsumablesInboundTabPage.prototype.handleSubmitBulk = function () {
    if (!this.selectedList.length) {
      this.$message.warn(this.t('请选择需要提交的数据'));
      return;
    }

    this.submitOrderAudit(this.selectedList);
  };

  ConsumablesInboundTabPage.prototype.submitOrderAudit = function (data) {
    var _this = this;

    this.$confirm({
      title: this.tc('温馨提示'),
      content: this.t('请确认是否提交？'),
      onOk: function onOk() {
        bulkRequest({
          title: _this.t('提交耗材入库'),
          titleWidth: 340,
          data: data,
          request: function request(item) {
            return __awaiter(_this, void 0, Promise, function () {
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    return [4, this.$api.wrapper.submitConsumableMaterialInbound({
                      order_code: item
                    }, {
                      showError: false
                    })];

                  case 1:
                    return [2, _a.sent()];
                }
              });
            });
          },
          content: function content(item) {
            return _this.tc('耗材入库单号') + _this.tc('：') + item;
          },
          onCancel: function onCancel() {
            _this.queryList();
          }
        });
      }
    });
  };

  ConsumablesInboundTabPage.prototype.handleMore = function (data, title) {
    this.rowData.title = title;
    this.rowData.data = data;
    this.moreWrapperVisible = true;
  };

  ConsumablesInboundTabPage.prototype.queryWarehouseList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, data;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4, this.$api.common.queryAllWarehouseList()];

          case 1:
            _a = _b.sent().data, data = _a === void 0 ? [] : _a;
            this.warehouseList = data;
            return [2];
        }
      });
    });
  };

  __decorate([enumData('Wrapper/InOrderStatusEnum')], ConsumablesInboundTabPage.prototype, "inOrderStatusEnum", void 0);

  __decorate([enumData('ConsumableTypeEnum')], ConsumablesInboundTabPage.prototype, "consumableTypeEnum", void 0);

  __decorate([User.State('customerInfo')], ConsumablesInboundTabPage.prototype, "customerInfo", void 0);

  __decorate([userPrefPageSize('wrapperInboundList')], ConsumablesInboundTabPage.prototype, "initSearchData", null);

  __decorate([loading('loadingStatus')], ConsumablesInboundTabPage.prototype, "queryList", null);

  ConsumablesInboundTabPage = __decorate([Component({
    components: {
      EditModal: EditModal,
      MoreWrapperModal: MoreWrapperModal
    }
  })], ConsumablesInboundTabPage);
  return ConsumablesInboundTabPage;
}(Vue);

export default ConsumablesInboundTabPage;